import { hasElementValidityProperty } from './hooks/useValidatedForm';

export function setCustomValidityOnField(form: HTMLFormElement, name: string, message: string) {
    const element = form.elements.namedItem(name);
    if (hasElementValidityProperty(element)) {
        element.setCustomValidity(message);
        return true;
    } else {
        console.error(message);
        return false;
    }
}
